import { render } from "./FeaturesSectionEditor.vue?vue&type=template&id=7b7e795f"
import script from "./FeaturesSectionEditor.vue?vue&type=script&lang=js"
export * from "./FeaturesSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__